import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/firms/$firmId/filings/"
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$organisation/firms/$firmId/authorisation",
      params: { organisation: params.organisation, firmId: params.firmId },
    })
  },
})
